import React, {
  createContext,
  useReducer,
  useEffect,
  useContext,
  useMemo,
} from 'react';

import { initialIntelState } from './index';
import Reducer from './IntelReducer';
import { IntelState } from '../@types/State';
export const STORAGE_KEY = 'IntelState';

export const parseState = (str: string | null) => {
  return (str ? JSON.parse(str) : {}) as IntelState;
};

const persistedState: IntelState = {
  ...initialIntelState,
  ...parseState(localStorage.getItem(STORAGE_KEY)),
};

const IntelContext = createContext<{
  intelState: IntelState;
  intelDispatch: React.Dispatch<any>;
}>({
  intelState: persistedState,
  intelDispatch: () => null,
});

interface Props {
  children: React.ReactNode;
}

const IntelProvider: React.FC<Props> = ({ children }) => {
  const [intelState, intelDispatch] = useReducer(Reducer, persistedState);
  const obj = useMemo(() => ({ intelState, intelDispatch }), [intelState]);
  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(intelState));
  }, [intelState]);
  return <IntelContext.Provider value={obj}>{children}</IntelContext.Provider>;
};

export function useIntelState() {
  return useContext(IntelContext);
}

export { IntelContext, IntelProvider };
